
import { getBackend } from '../api/backend';


let globalTimestampCache = null;
let globalTimestampCacheTime = 0;
const GLOBAL_TIMESTAMP_CACHE_DURATION = 5 * 1000; // 5 segundos

async function getGlobalTimestampCached() {
  if (globalTimestampCache && (Date.now() - globalTimestampCacheTime < GLOBAL_TIMESTAMP_CACHE_DURATION)) {
    return globalTimestampCache;
  }
  try {
    const globalResponse = await getBackend("global-last-modified");
    globalTimestampCache = parseInt(globalResponse.global_last_modified, 10);
    globalTimestampCacheTime = Date.now();
    return globalTimestampCache;
  } catch (error) {
    console.error("Error fetching global timestamp:", error);
    return null;
  }
}

/**
 * Fetches data with caching support.
 * @param {string} cacheKey - Key to use for localStorage
 * @param {function} fetchFunction - Async function to fetch data if cache is invalid
 * @param {number} expiryTime - Cache expiry time in milliseconds (default: 24 hours)
 * @returns {Promise<any>} - The data, either from cache or freshly fetched
 */
export const fetchWithCache = async (cacheKey, fetchFunction, expiryTime = 24 * 60 * 60 * 1000) => {
  let globalTimestamp;
  try {
    globalTimestamp = await getGlobalTimestampCached();
  } catch (error) {
    console.error("Error fetching global timestamp:", error);
  }

  // Revisar la caché en localStorage
  const cachedData = localStorage.getItem(cacheKey);
  const cacheTimestamp = localStorage.getItem(`${cacheKey}_timestamp`);

  if (cachedData && cacheTimestamp) {
    const cachedTimestamp = parseInt(cacheTimestamp, 10);
    const age = Date.now() - cachedTimestamp;
    // Se usa la caché si:
    // 1. No ha expirado según el expiryTime.
    // 2. Y el timestamp almacenado es mayor o igual al global (o no se pudo obtener el global).
    if (age < expiryTime && (globalTimestamp ? cachedTimestamp >= globalTimestamp : true)) {
      console.log(`Using cached ${cacheKey} data`);
      return JSON.parse(cachedData);
    }
  }

  console.log(`Fetching fresh ${cacheKey} data`);
  const freshData = await fetchFunction();

  try {
    // Reutiliza el timestamp cacheado para almacenar junto con los datos
    const updatedGlobalTimestamp = await getGlobalTimestampCached();
    localStorage.setItem(cacheKey, JSON.stringify(freshData));
    localStorage.setItem(`${cacheKey}_timestamp`, updatedGlobalTimestamp ? updatedGlobalTimestamp.toString() : Date.now().toString());
  } catch (error) {
    console.error("Error fetching global timestamp for cache storage:", error);
    // Fallback: almacenar con Date.now() en caso de error
    localStorage.setItem(cacheKey, JSON.stringify(freshData));
    localStorage.setItem(`${cacheKey}_timestamp`, Date.now().toString());
  }

  return freshData;
};
